import { createContext, useContext, useState, useEffect } from 'react'

interface RouterCtx {
  path: string
  search: URLSearchParams
  navigate: (to: string) => void
}

const Ctx = createContext<RouterCtx>({ path: '/', search: new URLSearchParams(), navigate: () => {} })

export function RouterProvider({ children }: { children: React.ReactNode }) {
  const [path,   setPath]   = useState(() => window.location.pathname)
  const [search, setSearch] = useState(() => new URLSearchParams(window.location.search))

  function navigate(to: string) {
    window.history.pushState({}, '', to)
    const url = new URL(to, window.location.origin)
    setPath(url.pathname)
    setSearch(new URLSearchParams(url.search))
    window.scrollTo({ top: 0, behavior: 'instant' })
  }

  useEffect(() => {
    function onPop() {
      setPath(window.location.pathname)
      setSearch(new URLSearchParams(window.location.search))
    }
    window.addEventListener('popstate', onPop)
    return () => window.removeEventListener('popstate', onPop)
  }, [])

  return <Ctx.Provider value={{ path, search, navigate }}>{children}</Ctx.Provider>
}

export function useRouter() { return useContext(Ctx) }

interface LinkProps {
  href: string
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
  onClick?: () => void
}

export function Link({ href, children, className, style, onClick }: LinkProps) {
  const { navigate } = useRouter()
  return (
    <a
      href={href}
      onClick={e => { e.preventDefault(); onClick?.(); navigate(href) }}
      className={className}
      style={style}
    >
      {children}
    </a>
  )
}
